import api from './api';

// CRUD for ESB receivers & pollers (v2_receivers_pollers), served by the ESB API.
export const receiversPollersService = {
  list: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.partner_id) params.append('partner_id', filters.partner_id);
    if (filters.account_id) params.append('account_id', filters.account_id);
    if (filters.hotel_id) params.append('hotel_id', filters.hotel_id);
    if (filters.kind) params.append('kind', filters.kind);
    if (filters.status) params.append('status', filters.status);
    if (filters.connector_type_id) params.append('connector_type_id', filters.connector_type_id);
    if (filters.name) params.append('name', filters.name);
    if (filters.limit) params.append('limit', filters.limit);
    const qs = params.toString();
    const res = await api.get(`/admin/receivers-pollers${qs ? `?${qs}` : ''}`);
    return res.data;
  },

  get: async (id) => (await api.get(`/admin/receivers-pollers/${id}`)).data,

  create: async (data) => (await api.post('/admin/receivers-pollers', data)).data,

  update: async (id, data) => (await api.put(`/admin/receivers-pollers/${id}`, data)).data,

  remove: async (id) => (await api.delete(`/admin/receivers-pollers/${id}`)).data,
};

export default receiversPollersService;
